export default "__VITE_ASSET__BJr_k4Ra__"